import { FiUpload } from "react-icons/fi";

const ExportDataExcelBE = ({ title, id_employee, extra }) => {
  const handleExport = async () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/${title}/exportExcel/${
      extra ? extra : ""
    }${id_employee}`;
     const key = localStorage.getItem("authkey");
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${key}`, 
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Export failed");
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `${title}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      alert("Export failed: " + error.message);
    }
  };

  return (
    <button
      onClick={handleExport}
      className="border flex justify-center items-center border-gray-300 hover:border-green-400 hover:text-green-400 dark:text-gray-300 cursor-pointer h-10 w-20 rounded-md focus:outline-none"
    >
      <FiUpload className="mr-2" />
      <span className="text-xs">Export</span>
    </button>
  );
};

export default ExportDataExcelBE;
